export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-2a964870e75a29da4e97.worker.js");
}
